import * as Yup from 'yup';
import moment from 'moment';

export const dateNow = moment().toISOString();
export const dateStartOfMonth = moment().startOf('month').toISOString();

export const productRulesValidationSchema = Yup.object().shape({
  providerId: Yup.string().required(),
  productTypeId: Yup.string().required(),
  startDate: Yup.string().required(),
  endDate: Yup.string().required(),
  ilendingCostAmount: Yup.number().nullable().min(0),
  ilendingCostFormula: Yup.string().max(48),
  packAmount: Yup.number().nullable().min(0),
  packFormula: Yup.string().max(48),
  markupAmount: Yup.number().nullable().min(0),
  markupFormula: Yup.string().max(48),
  state: Yup.string().nullable(),
  minTerm: Yup.number().nullable().min(0),
  maxTerm: Yup.number().nullable().min(0),
});
